<template>
  <div class="ui clearing form red segment"> 
    <div class="two fields">
      <div class="field">
        <label for="">Final cost price</label>
        <div class="ui input" :class="{'disabled': isDisabled}">
          <input 
            type="number" 
            placeholder="Final cost price"
            v-model="costForm.finalCostPrice"
          />
        </div>
      </div>
      <div class="field">
        <label for="">Final selling price</label>
        <div class="ui input" :class="{'disabled': isDisabled}">
          <input 
            type="number" 
            placeholder="Final selling price"
            v-model="costForm.finalSellingPrice"
          />
        </div>
      </div>
    </div>
    <div class="field">
      <label for="">Final doctor percentage</label>
      <div class="ui input" :class="{'disabled': isDisabled}"> 
        <input 
          type="number" 
          placeholder="Final doctor percentage"
          v-model="costForm.finalDoctorPercentage"
        />
      </div>
    </div>

    <div class="ui red fluid button" @click="isDisabled = !isDisabled">
      {{ isDisabled ? 'Change' : 'Don\'t change'}} prices
    </div>
  </div>
</template>

<script>
export default {
  props: {
    visitDetailIndex: { type: Number, required: true }
  },
  data() {
    return {
      isDisabled: true,
      costForm: {
        finalCostPrice: null,
        finalSellingPrice: null,
        finalDoctorPercentage: null
      }
    };
  },
  watch: {
    costForm: {
      handler: function() {
        if (this.costForm.finalCostPrice === "") {
          this.costForm.finalCostPrice = null
        }
        
        if (this.costForm.finalSellingPrice === "") {
          this.costForm.finalSellingPrice = null
        }

        if (this.costForm.finalDoctorPercentage === "") {
          this.costForm.finalDoctorPercentage = null
        }

        this.$emit('onCostFormUpdate', {
          finalCostPrice: this.costForm.finalCostPrice,
          finalSellingPrice: this.costForm.finalSellingPrice,
          finalDoctorPercentage: this.costForm.finalDoctorPercentage,
          visitDetailIndex: this.visitDetailIndex
        });
      },
      deep: true
    },
    isDisabled () {
      if (this.isDisabled) {
        this.onDisablePrices()
      }
    }
  },
  methods: {
    onDisablePrices() {
      this.costForm.finalCostPrice = null;
      this.costForm.finalSellingPrice = null;
      this.costForm.finalDoctorPercentage = null;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/visits/finalize-visits-components/FinalPrices.vue